import { Observable } from 'rxjs';

import { AudioChannelFeatureUpdateInput } from '@shure/shared/angular/data-access/system-api/core';
import { BeamWidth, PolarPattern, Response } from '@shure/shared/angular/data-access/system-api/models';
import { PositionPoint } from '@shure/shared/angular/utils/utils-position';

export interface CoverageAudioChannelPostGateConfig {
	channelId: string;
	isPostGate: boolean;
	/** When true, mute updates target preGateMute (DCA901/DCA720). */
	isPreGate?: boolean;
}

export abstract class CoverageAudioChannelApiService {
	public abstract setAudioChannelPosition(channelId: string, position: PositionPoint): Observable<void>;
	public abstract setAudioChannelTalkerHeight(channelId: string, talkerHeight: number): Observable<void>;

	public abstract setAudioChannelMicrophoneAngle(
		channelUpdates: { channelId: string; angle: number }[]
	): Observable<void>;

	public abstract setAudioChannelName(channelId: string, channelName: string): Observable<Response<void, string>>;

	public abstract setAudioChannelsMute(
		audioChannelMuteConfig: CoverageAudioChannelPostGateConfig[],
		muted: boolean
	): Observable<void>;

	public abstract setAudioChannelGain(
		gainConfig: CoverageAudioChannelPostGateConfig[],
		gain: number
	): Observable<void>;

	public abstract setAudioChannelsIdentify(channelIds: string[], identifying: boolean): Observable<void[]>;
	public abstract setAudioChannelsCoverageViewLock(channelIds: string[], enabled: boolean): Observable<void>;
	public abstract setAudioChannelsPolarPattern(channelIds: string[], polarPattern: PolarPattern): Observable<void>;
	public abstract setAudioChannelsBeamWidth(channelIds: string[], width: BeamWidth): Observable<void>;
	public abstract addAudioChannels(channelIds: string[]): Observable<void>;
	public abstract removeAudioChannels(channelIds: string[]): Observable<void>;
	public abstract resetLobePosition(channelId: string): Observable<void>;
	public abstract updateChannelProperty(channelId: string, update: AudioChannelFeatureUpdateInput): Observable<void>;
}
